import { BoxProps } from '@mui/system';
import { Types } from '@scorenco/core';

import { EventPostActionItem } from './EventPostActionItem';
import { EventPostCommentItem } from './EventPostCommentItem';
import { EventPostItemFragment } from './EventPostItem.fragment.generated';

export const EventPostItem = ({
  eventPost,
  event,
  live,
  ...rest
}: EventPostItemProps) => {
  if (eventPost?.deleted) {
    return null;
  }

  if (eventPost?.action) {
    return (
      <EventPostActionItem
        eventPost={eventPost}
        event={event}
        live={live}
        {...rest}
      />
    );
  }

  return <EventPostCommentItem eventPost={eventPost} event={event} {...rest} />;
};

export type EventPostItemProps = BoxProps & {
  eventPost?: EventPostItemFragment;
  event?: Types.Competitions_Event_Detail;
  live?: Types.Lives_Live;
};
